import './pureperfection/style';
import FormStructure from './pureperfection/form_structure';

export default FormStructure;